// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"CopyArea-primaryButton-3yTntP","topArea":"CopyArea-topArea-1jW_hV","label":"CopyArea-label-iqg6u0","button":"CopyArea-button-14eZw9"};